<mat-slider color="primary" [min]="min" [max]="max" showTickMarks discrete
  (change)="onSliderChange()" disableRipple>
  <input matSliderThumb [formControl]="inputCtrl">
</mat-slider>
<p class="slider-label" *ngIf="inputCtrl.value">
  <span class="prefix">{{ prefix }}</span>
  <span class="value">{{ inputCtrl.value }}</span>
</p>